module.exports = __webpack_public_path__ + "images/60e8a8323a1f5c9dc59c6783d5974123.png";